import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterSelect, FilterTimePicker, FilterCheckBox } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import { paymentMethodStatus } from '../../enums/paymentMethodStatus';
import { paymentMethodType } from '../../enums/paymentMethodType';
import {
  DisplayDate,
  DisplayGuid,
  DisplayStatus,
  DisplayType
} from '../items';

const resultsCount = 15;

class PaymentMethodsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { paymentMethods: { searchPaymentMethods } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchPaymentMethods({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { history, location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Payment methods list'
              documentDescription='Payment methods list'
            />
            <h2 className='main-page-header'>
              Payment Methods
            </h2>
            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                paymentMethodId,
                userId,
                displayName,
                status,
                afterAt,
                beforeAt,
                isDefault
              }, updatedKey) => {
                if (updatedKey !== 'paymentMethodId') {
                  return {
                    userId,
                    displayName,
                    status,
                    afterAt,
                    beforeAt,
                    isDefault
                  };
                }
                return { paymentMethodId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='paymentMethodId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='paymentMethodId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='userId'>
                      User Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='userId'
                      placeholder='Filter by user id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='displayName'>
                      Display Name
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='displayName'
                      placeholder='Filter by display name'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='status'>
                      Status
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='status'
                      options={paymentMethodStatus}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='afterAt'>
                      From
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='afterAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='beforeAt'>
                      To
                    </label>
                    <FilterTimePicker
                      className='filter-date-picker'
                      data={formData}
                      update={update}
                      name='beforeAt'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='isDefault'>
                      Show only default payment methods
                    </label>
                    <FilterCheckBox
                      data={formData}
                      debounce
                      update={update}
                      name='isDefault'
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'paymentMethods',
                rowClasses: 'hover-listview',
                rowClick: ({ Id, Type }) => {
                  history.push(`/paymentmethod/${Type}/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }, {
                    property: 'Status',
                    label: 'Status',
                    render: ({ Status }) => <DisplayStatus mapping={paymentMethodStatus}>{Status}</DisplayStatus>
                  }, {
                    property: 'Name',
                    label: 'Name',
                    type: 'string'
                  }, {
                    property: 'Token',
                    label: 'Token',
                    type: 'string'
                  }, {
                    property: 'Type',
                    label: 'Type',
                    render: ({ Type }) => <DisplayType mapping={paymentMethodType}>{Type}</DisplayType>
                  }, {
                    property: 'CreatedAtCet',
                    label: 'CreatedAt (CET)',
                    render: ({ CreatedAtCet }) => <DisplayDate>{CreatedAtCet}</DisplayDate>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);
                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const PaymentMethods = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(PaymentMethodsInternal)));

PaymentMethods.requiresLogin = true;
PaymentMethods.propTypes = { isLoggedIn: PropTypes.bool };

export default PaymentMethods;
